import type { GarmentGeometry } from '@seddi/scene';
import { PieceExt } from './pieceExt';

type Pieces = Map<string, PieceExt>;

/**
 * Scene extension.
 */
export class SceneExt {
  /** Garment geometry data. */
  public garmentGeometry?: GarmentGeometry;
  /** Pieces data. */
  public readonly pieces: Pieces;

  /**
   * Creates a new cache.
   */
  constructor() {
    this.pieces = new Map<string, PieceExt>();
  }

  /**
   * Releases resources associated with this cache.
   */
  public dispose() {
    this.garmentGeometry = undefined;
    this.pieces.clear();
  }

  /**
   * Returns an existing piece or creates if not available.
   * @param pieceId - Piece ID.
   */
  addPiece(pieceId: string) {
    const { pieces } = this;

    // Create piece if not available.
    if (!pieces.has(pieceId)) {
      const piece = new PieceExt();
      this.pieces.set(pieceId, piece);
    }

    return this.pieces.get(pieceId);
  }

  /**
   * Removes an existing piece.
   * @param pieceId - Piece ID.
   */
  removePiece(pieceId: string) {
    this.pieces.delete(pieceId);
  }
}
